<ng-container *ngIf="!datosRecibidos && errorMessage === ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <span class="wait-message">Cargando datos...</span>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage !== ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <div class="wait-message">{{ errorMessage }}</div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage === '' && datosRecibidos">
    <div class="table-header">
        <div class="header-content">
            <span>Configuración actual de alarmas</span>
            <button mat-icon-button [matMenuTriggerFor]="menu" class="more-vert-btn">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>

        <span class="font14">Tanques DataBeer con alguna configuración de alarma establecida</span>

        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="descargarExcel()">
                <mat-icon>download</mat-icon>
                <span>Exportar a Excel</span>
            </button>
        </mat-menu>
    </div>

    <div class="mat-elevation-z8">
        <div class="top-container-container">
            <div class="top-container">
                <mat-form-field class="custom1">
                    <mat-label>Filtrar</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Ex.nombre" #input>
                </mat-form-field>
            </div>
        </div>

        <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="numeroTanque">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nº Tanque </th>
                <td mat-cell *matCellDef="let element" class="router-cell-primaria" routerLink="/tanques/{{element.tanqueID}}/editar"> {{element.numeroTanque}} </td>
            </ng-container>

            <ng-container matColumnDef="deviceLabel">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Dispositivo </th>
                <td mat-cell *matCellDef="let element" class="router-cell" routerLink="/dispositivo/ver/{{element.deviceID}}"> {{element.deviceLabel}} ({{element.deviceReference}}) </td>
            </ng-container>

            <ng-container matColumnDef="establishmentName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Establecimiento </th>
                <td mat-cell *matCellDef="let element" class="router-cell" routerLink="/establecimiento/{{element.establishmentID}}"> {{element.establishmentName}} </td>
            </ng-container>

            <ng-container matColumnDef="nivelAlarm">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nivel </th>
                <td mat-cell *matCellDef="let element" class="cell">
                    <ng-container *ngIf="element.nivelAlarm !== null">
                        {{ element.nivelAlarm }} %
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="temperaturaAltaAlarm">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Temperatura Máx</th>
                <td mat-cell *matCellDef="let element" class="cell">{{element.temperaturaAltaAlarm}}</td>
            </ng-container>

            <ng-container matColumnDef="temperaturaBajaAlarm">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Temperatura Mín</th>
                <td mat-cell *matCellDef="let element" class="cell">{{element.temperaturaBajaAlarm}}</td>
            </ng-container>

            <ng-container matColumnDef="presionAltaAlarm">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Presión Máx</th>
                <td mat-cell *matCellDef="let element" class="cell">{{element.presionAltaAlarm}}</td>
            </ng-container>

            <ng-container matColumnDef="presionBajaAlarm">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Presión Mín</th>
                <td mat-cell *matCellDef="let element" class="cell">{{element.presionBajaAlarm}}</td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator 
            [pageSizeOptions]="[20,40,80]" 
            showFirstLastButtons 
            aria-label="Elige una página"
            class="custom4">
        </mat-paginator>
    </div>
</ng-container>
